export class SharedErrorHelper {
    /**
     * Get error ID from API (separated by :::)
     * @param errorMessage
     */
    public static getErrorId(errorMessage: string): string {
        return errorMessage.split(':::')[0];
    }
}
